import { MinimumStationsGroup, Station } from '@mi-front/core';
import { Field, FieldProps } from 'formik';
import { StationsAdvancedFilter } from '../StationsAdvancedFilter';

export interface StationsAdvancedFilterFieldFormikProps {
  name: string;
  label?: string;
  placeholder?: string;
  multiple?: boolean;
  /** Use `small` for 40px height to match other MUI small inputs. */
  size?: 'small' | 'medium';
  stations?: Station[];
  stationGroups?: MinimumStationsGroup[];
  disabled?: boolean;
}

export function StationsAdvancedFilterFieldFormik({
  name,
  label,
  placeholder,
  multiple = true,
  size,
  stations,
  stationGroups,
  disabled,
}: StationsAdvancedFilterFieldFormikProps): JSX.Element {
  return (
    <Field name={name}>
      {(fieldProps: FieldProps) => {
        const { field, meta } = fieldProps;

        return (
          <StationsAdvancedFilter
            stations={stations || []}
            stationGroups={stationGroups || []}
            value={field.value || []}
            onChange={(selectedOptions) => {
              field.onChange({
                target: {
                  name: field.name,
                  value: selectedOptions,
                },
              });
            }}
            multiple={multiple}
            size={size}
            label={label}
            placeholder={placeholder}
            disabled={disabled}
            error={!!(meta.touched && meta.error)}
            helperText={meta.touched && meta.error ? meta.error : undefined}
          />
        );
      }}
    </Field>
  );
}
